import React from "react";
var __jsx = React.createElement;
import { useEffect, useState } from 'react';
import { useLang } from "@/common/Contexts/LanguageContext";
import stl from './WithScrollToTop.module.css';
import useIsMobile from "@hooks/useIsMobile";
var DEFAULT_THRESHOLD = 500;
var DEFAULT_MARGIN_PERCENTAGE_Vertical = 13;
var DEFAULT_MARGIN_PERCENTAGE_Horizontal = 4.8;
var WithScrollToTop = function WithScrollToTop(_ref) {
  var _ref$threshold = _ref.threshold,
    threshold = _ref$threshold === void 0 ? DEFAULT_THRESHOLD : _ref$threshold,
    renderFunction = _ref.renderFunction,
    _ref$position = _ref.position,
    position = _ref$position === void 0 ? null : _ref$position,
    _ref$marginPercentage = _ref.marginPercentageVertical,
    marginPercentageVertical = _ref$marginPercentage === void 0 ? DEFAULT_MARGIN_PERCENTAGE_Vertical : _ref$marginPercentage,
    _ref$marginPercentage2 = _ref.marginPercentageHorizontal,
    marginPercentageHorizontal = _ref$marginPercentage2 === void 0 ? DEFAULT_MARGIN_PERCENTAGE_Horizontal : _ref$marginPercentage2;
  var lang = useLang();
  var isMobile = useIsMobile();
  position = position || (lang === 'en' ? 'BOTTOM_LEFT' : "BOTTOM_RIGHT");
  var _useState = useState(false),
    showScroll = _useState[0],
    setShowScroll = _useState[1];
  var _useState2 = useState(false),
    isMouseOver = _useState2[0],
    setIsMouseOver = _useState2[1];
  useEffect(function () {
    if (!isMobile) return;
    var handleScroll = function handleScroll() {
      if (window.scrollY > threshold) {
        setShowScroll(true);
      } else {
        setShowScroll(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return function () {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [threshold, isMobile]);
  var handleScrollToTop = function handleScrollToTop() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  var positionStyles = {
    bottom: "".concat(marginPercentageVertical, "%"),
    right: position === 'BOTTOM_RIGHT' ? "".concat(marginPercentageHorizontal, "%") : position === 'BOTTOM_CENTER' ? '50%' : 'auto',
    left: position === 'BOTTOM_LEFT' ? "".concat(marginPercentageHorizontal, "%") : position === 'BOTTOM_CENTER' ? '50%' : 'auto',
    transform: position === 'BOTTOM_CENTER' ? 'translateX(-50%)' : 'none',
    //when mouse is over the icon should change opacity and appear darker
    filter: isMouseOver ? 'brightness(0.93)' : 'none'
  };
  return /*#__PURE__*/React.createElement("div", {
    id: "WithScrollToTop",
    className: [stl.wrapper, showScroll && stl.show].join(' '),
    style: positionStyles,
    onMouseOver: function onMouseOver() {
      return setIsMouseOver(true);
    },
    onMouseOut: function onMouseOut() {
      return setIsMouseOver(false);
    }
  }, renderFunction({
    onClick: handleScrollToTop,
    isMouseOver: isMouseOver
  }));
};
export default WithScrollToTop;